import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {ProductImageManagerComponent} from "../../components/product-image-manager/product-image-manager.component";
import {UiModalComponent} from "../../shared/ui";
import { AppLogger, AppLoggerService } from '../../core/logging';

@Component({
  selector: 'app-product-image-dialog',
  imports: [
    ProductImageManagerComponent,
    UiModalComponent
  ],
  templateUrl: './product-image-dialog.component.html',
  styleUrl: './product-image-dialog.component.scss'
})
export class ProductImageDialogComponent {

  private readonly log: AppLogger;

  @Input() productId: number | null = null;

  @Output() modalClosed = new EventEmitter<void>();

  @ViewChild(UiModalComponent) modal!: UiModalComponent;
  @ViewChild(ProductImageManagerComponent) manager?: ProductImageManagerComponent;

  constructor(private appLogger: AppLoggerService) {
    this.log = this.appLogger.createForClass(ProductImageDialogComponent);
  }

  get hasProductId(): boolean {
    return this.productId !== null;
  }

  /**
   * Open the dialog. `startInSearch` lands directly on the image-search panel,
   * which is what the detail page's "Search image" action wants — the modal
   * body is always projected, so the manager exists before the dialog is shown.
   */
  open(startInSearch = false) {
    this.modal.open();
    if (startInSearch) {
      this.manager?.openSearch();
    } else {
      this.manager?.closeSearch();
    }
  }

  close() {
    this.log.debug('Product image dialog close() called');
    // Don't call this.modal.close() here - the modal is already closing
    // This method is called FROM the modal's (modalClosed) event
    this.log.debug('Product image dialog emitting modalClosed event');
    this.modalClosed.emit();
  }

}
